import { ApiClient } from "client/base";
import { delay } from "utils/promise";
import { isObject } from "types/base";
import { isAzureAccount } from "types/account";
const isPredictStatusResponse = (x) => {
    return isObject(x) && "id" in x && x.status == "INPROGRESS";
};
export class CloudProjectClient extends ApiClient {
    config;
    account;
    accountClientWithoutFactory;
    constructor(base, config, account, accountClientWithoutFactory) {
        super(base);
        this.config = config;
        this.account = account;
        this.accountClientWithoutFactory = accountClientWithoutFactory;
    }
    deploy(project) {
        return this.base.post("v1/projects", project);
    }
    whatIf(projectId, jobId, modelName, rows) {
        const payload = {
            data: rows,
            options: {
                project_id: projectId,
                job_id: jobId,
                model_name: modelName,
                format: "csv",
                apply_transformations: false
            }
        };
        const url = "v1/deploy/new";
        const poll_url = "v1/deploy";
        return this.base.post(url, payload).then((response) => this.handle_predict_response(poll_url, response));
    }
    poll_predict(base, response) {
        const promise = false && isAzureAccount(this.account) ? this.base.get(response.url) : this.base.get(`${base}/${response.id}`);
        return promise.then((response) => delay(1000).then(() => this.handle_predict_response(base, response)));
    }
    handle_predict_response(base, response) {
        if (isPredictStatusResponse(response)) {
            return this.poll_predict(base, response);
        }
        return Promise.resolve(response);
    }
    // This is the start of the bulk api workflow for predicting
    async bulk_predict(projectId, file, payload = {}) {
        // NOTE: We could test that the file type is the same as the options that are being passed as a means to premptively stop bad options from being passed.
        const bulk_upload = await this.bulk_upload(projectId, payload);
        // We have to wait for the file to upload to the bucket
        await this.accountClientWithoutFactory.presignedPutRequest(this.account, bulk_upload.url, file);
        // TODO: Maybe we should handle the cases that this fails to upload, return an error, or at least attempt to reupload it till the url is invalid?
        const bulk_start = await this.bulk_start(bulk_upload.id);
        const poll_response = await this.bulk_status(bulk_start.prediction_id);
        return this.poll_bulk_status(poll_response);
    }
    bulk_upload(projectId, payload) {
        return this.base.post(`v1/deploy/bulk/upload/${projectId}`, payload);
    }
    bulk_start(id) {
        return this.base.post(`v1/deploy/bulk/start/${id}`);
    }
    async bulk_status(prediction_id) {
        const response = await this.base.get(`v1/deploy/bulk/status/${prediction_id}`);
        return Promise.resolve({
            prediction_id,
            response: response
        });
    }
    async poll_bulk_status({ prediction_id, response }) {
        if (response.status != "INPROGRESS") {
            return Promise.resolve(response);
        }
        // Wait a bit before we try to get the status again.
        await delay(1000);
        const inner_response = await this.bulk_status(prediction_id);
        return this.poll_bulk_status(inner_response);
    }
}
